import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";
import { GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { config } from "../../../config";
import { isValidChatMessage } from "../../../utils/textUtils";

export const ChatFooterInput = ({ chatMessage, onSendMessage, onMessageChangeHandler }) => {
  const intl = useIntl();
  const [message, setMessage] = useState();
  const [messageError, setMessageError] = useState();

  const handleMessageChange = (value) => {
    const cleanMessage = value.trim().length === 0 ? value.trim() : value;
    setMessage(cleanMessage);
    onMessageChangeHandler(cleanMessage);
    setMessageError(cleanMessage?.length === config.MAX_LIVE_CHAT_MESSAGE_LENGTH);
  };

  const onKeyDownHandler = (event) => {
    if (event.keyCode === 13 && !event.shiftKey) {
      if (!isValidChatMessage(message)) {
        return;
      }

      event.preventDefault();
      onSendMessage(message);
      setMessage("");
      onMessageChangeHandler("");
    }
  };

  useEffect(() => {
    setMessage(chatMessage);
    setMessageError(chatMessage?.length === config.MAX_LIVE_CHAT_MESSAGE_LENGTH);
  }, [chatMessage]);

  return (
    <GridItem gridRow="1" gridColumn="1 / span 8">
      <Form.Input
        size="small"
        id="liveChatMessage"
        name="liveChatMessage"
        value={message}
        autoComplete="off"
        minLength={config.MIN_LIVE_CHAT_MESSAGE_LENGTH}
        maxLength={config.MAX_LIVE_CHAT_MESSAGE_LENGTH}
        placeholderMessage={intl.formatMessage({
          id: "live_sessions.chat.footer.input.placeholder",
        })}
        hasError={messageError}
        onChange={(event) => handleMessageChange(event.target.value)}
        onKeyDown={onKeyDownHandler}
      />
    </GridItem>
  );
};

ChatFooterInput.propTypes = {
  chatMessage: PropTypes.string,
  onMessageChangeHandler: PropTypes.func.isRequired,
  onSendMessage: PropTypes.func.isRequired,
};

ChatFooterInput.defaultProps = {
  chatMessage: "",
};

export default ChatFooterInput;
